import DropdownTemplateView from '../../../../DropdownTemplateView'
import {trim} from '../../../../atUtils'
import {corporateHolidayEditorModes} from '../../constants'
import messageResource from '../../../../messageResource'
import $ from 'jquery'

export default class CorporateHolidayEditor extends DropdownTemplateView {
    constructor({
        editCallback = () => {},
        deleteCallback = () => {},
    } = {}) {
        super()

        this.callbacks = {
            editCallback,
            deleteCallback,
        }

        this.state = {
            date: null,
            title: '',
            showMarkAsWorkingButton: false,
            mode: corporateHolidayEditorModes.CHANGE_NAME,
        }

        this.onStatePropertyChanged('showMarkAsWorkingButton', (show) => this.$additionalOptions.toggle(show))

        this.onStatePropertyChanged('title', (title) => {
            this.$title.pVal(title)
        })
    }

    templateHtml() {
        return '<div class="corporateHolidayEditor">' +
               '    <div class="editorSection">' +
               '        <div class="titleInput">' +
               '            <input type="text" maxlength="80"/>' +
               '        </div>' +
               '        <div class="separator"/>' +
               '        <div class="deleteIcon"/>' +
               '    </div>' +
               '    <div class="additionalOptions">' +
               '        <span class="markAsWorkingButton"><%=markAsWorking%></span>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            markAsWorking: 'work_schedule.mark_as_working_day',
        }
    }

    afterRender() {
        this.$title = this.find('.titleInput input')
        this.$additionalOptions = this.find('.additionalOptions')

        this.$delete = this.find('.deleteIcon')
        this.$delete.click(() => {
            this.setStateInternal({
                mode: corporateHolidayEditorModes.DELETE,
            })
            this.callbacks.deleteCallback(this.state.date)
            this.hide()
        })

        this.$markAsWorkingButton = this.find('.markAsWorkingButton')
        this.$markAsWorkingButton.click(() => {
            if (this.state.showMarkAsWorkingButton) {
                this.setStateInternal({
                    mode: corporateHolidayEditorModes.MARK_AS_WORKING,
                })
                this.callbacks.editCallback(this.state.date, true, '')
            }
            this.hide()
        })

        this.renderInitialState()
    }

    onShow() {
        super.onShow()
        this.onShowCallback()
        this.setStateInternal({
            mode: corporateHolidayEditorModes.CHANGE_NAME,
        })
    }

    setOnShowCallback(callback) {
        this.onShowCallback = callback
    }

    onHide() {
        super.onHide()
        this.onHideCallback()
        if (this.state.mode === corporateHolidayEditorModes.CHANGE_NAME) {
            let newTitle = trim(this.$title.pVal()) === ''
                ? messageResource.getMessage('work_schedule.corporate_holiday')
                : trim(this.$title.pVal())
            if (this.state.title !== newTitle)
                this.callbacks.editCallback(this.state.date, false, newTitle)
        }
    }

    setOnHideCallback(callback) {
        this.onHideCallback = callback
    }

    mouseDownTargetElement() {
        return $(document)
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/month/CorporateHolidayEditor.js